var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#02955F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6641 31V11L11 13.0349V28.8801L22.6641 31ZM31.2086 13.33H23.1654V14.4074H26.0811V16.4724H23.1654V17.092H26.0811V19.157H23.1654V19.7765H26.0811V21.8416H23.1654V22.4611H26.0811V24.5262H23.1654V25.1457H26.0811V27.2108H23.1654V28.7147H31.2086V13.33ZM30.0022 14.4074H26.6844V16.4724H30.0022V14.4074ZM26.6844 17.092H30.0022V19.157H26.6844V17.092ZM30.0022 19.7765H26.6844V21.8416H30.0022V19.7765ZM26.6844 22.4611H30.0022V24.5262H26.6844V22.4611ZM30.0022 25.1457H26.6844V27.2108H30.0022V25.1457Z",
    fill: "#02955F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6754 19.4526L18.2112 16.9971H19.2058L17.1815 20.1743L19.2542 23.4043H18.2508L16.6754 20.9048L15.0912 23.4043H14.0923L16.1694 20.1743L14.1407 16.9971H15.1308L16.6754 19.4526Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.643ced1001e750398aa827efab5231dc.svg";
export { ForwardRef as ReactComponent };